import React from "react";
import { Card } from "@/components/ui/card";
import { Quote } from "lucide-react";

// Mirrors the public IssueDetailPage layout so editors see exactly what readers will.
export const WebPreviewTab = ({ issue }) => (
  <Card className="p-8 bg-[color:var(--coh-paper)]" data-testid="web-preview">
    <div className="mx-auto max-w-2xl">
      <div className="flex items-center gap-3 text-xs text-muted-foreground">
        <span className="font-mono text-[color:var(--coh-blue)]">Issue #{String(issue.issue_number || 0).padStart(3, "0")}</span>
        {issue.theme && <><span>·</span><span className="uppercase tracking-widest text-[10px] font-semibold">{issue.theme}</span></>}
      </div>
      <h1 className="mt-4 font-display text-4xl font-bold tracking-[-0.02em] leading-[1.08] text-[color:var(--coh-ink)]">{issue.title || "(Untitled)"}</h1>
      {issue.excerpt && <p className="mt-3 text-lg text-muted-foreground">{issue.excerpt}</p>}
      <div className="prose-editorial mt-8">
        {(issue.opening_markdown || "").split(/\n\n+/).map((p, idx) => <p key={idx}>{p}</p>)}
      </div>

      {issue.inspiring_quote?.text && (
        <figure className="mt-8 pull-quote" data-testid="web-preview-quote">
          <Quote aria-hidden="true" className="h-6 w-6 text-[color:var(--coh-cyan)]" />
          <blockquote className="mt-3 font-display text-2xl leading-snug text-[color:var(--coh-ink)]">“{issue.inspiring_quote.text}”</blockquote>
          {issue.inspiring_quote.author && <figcaption className="mt-4 kicker">— {issue.inspiring_quote.author}</figcaption>}
        </figure>
      )}

      {issue.reconnect_prompt?.headline && (
        <div className="mt-8 p-6 callout-blue">
          <div className="kicker">The Reconnect Prompt</div>
          <h2 className="mt-2 font-display text-2xl font-bold text-[color:var(--coh-ink)]">{issue.reconnect_prompt.headline}</h2>
          <p className="mt-2">{issue.reconnect_prompt.body}</p>
        </div>
      )}
      {issue.message_template && (
        <div className="mt-6 p-6 callout-paper">
          <div className="kicker">What to send</div>
          <pre className="mt-2 whitespace-pre-wrap font-mono text-sm bg-[color:var(--coh-paper)] p-4 rounded border border-border">{issue.message_template}</pre>
        </div>
      )}
      {issue.weekly_challenge?.headline && (
        <div className="mt-6 p-6 callout-cyan">
          <div className="kicker" style={{ color: "var(--coh-navy)" }}>The Small Action</div>
          <h3 className="mt-2 font-display text-xl font-bold text-[color:var(--coh-ink)]">{issue.weekly_challenge.headline}</h3>
          <ol className="mt-3 list-decimal list-inside">
            {(issue.weekly_challenge.steps || []).map((s, i) => <li key={i}>{s}</li>)}
          </ol>
        </div>
      )}
      {issue.closing_question && (
        <div className="mt-8 p-6 callout-purple">
          <div className="kicker" style={{ color: "var(--coh-purple)" }}>Closing question</div>
          <p className="mt-2 italic font-display text-xl text-[color:var(--coh-ink)]">{issue.closing_question}</p>
        </div>
      )}
    </div>
  </Card>
);
